
import { Modal } from 'antd';
import { PermissionCrudService } from '../../apis/mgmt/PermissionCrudService';
import { FindPermissionByDomainParams, Permission, findPermissionByDomain, findPermissionByUser } from '../../apis/mgmt/api';
import { readOnly, useReadOnly } from '../common/DataView';
import { useStatefulApiEditable } from '../common/Editable';
import { useApiFilteredList } from '../common/FilteredPaginatedList';
import { ListProps, SectionListLayout, useListWithEditable, useStatefulList } from '../common/List';
import { useStatefulToggleable } from "../common/Toggleable";
import { PermissionCard } from './PermissionCard';
import { PermissionEditable } from './PermissionEditable';

export const usePermissionListByDomain = function (props: {
    domainId: string | undefined,
}) {
    return useApiFilteredList<string,Permission>({
        filterProps: useReadOnly(props.domainId),
        listProps: useStatefulList<Permission>(),
        apiQueryFunc: (domainId) => findPermissionByDomain(domainId, {size:1000}).then((response) => {
            return Promise.resolve({ data: response.data?.content || [] });
        }),
    });
};

export const usePermissionListByUser = function (props: {
    userId: string | undefined,
}) {
    return useApiFilteredList<string,Permission>({
        filterProps: useReadOnly(props.userId),
        listProps: useStatefulList<Permission>(),
        apiQueryFunc: (userId) => findPermissionByUser(userId, {size:1000}).then((response) => {
            return Promise.resolve({ data: response.data?.content || [] });
        }),
    });
};

export function PermissionSectionList(props: {
    listProps: ListProps<Permission>,
    defaultAddItemData?: Permission,
    title?: string,
}) {

    const permissionToggle = useStatefulToggleable(false);
    const { listProps, editableProps: permissionEditableProps } = useListWithEditable<Permission>({
        listProps: props.listProps,
        editableProps: useStatefulApiEditable(PermissionCrudService, undefined, undefined, permissionToggle),
        toggle: permissionToggle,
        defaultAddItemData: props.defaultAddItemData,
    });

    const { onAddItem, onEditItem } = listProps;
    const data = listProps.data;

    return (
        <>
            <SectionListLayout
                title={props.title || 'Permissions'}
                onCreateClick={onAddItem}
                addButtonState={
                    props.defaultAddItemData?.role?.domain?.id || props.defaultAddItemData?.user?.id? 'visible' : 'disabled'
                } 
            >
                {data && data.map((itemData: Permission) => (
                    <PermissionCard
                        key={itemData.id}
                        data={itemData} {...readOnly}
                        onClick={onEditItem}
                    />
                ))}
            </SectionListLayout>
            <Modal open={permissionToggle && permissionToggle.visible} onCancel={permissionEditableProps.cancel}
                title={
                    <div style={{ width: '100%', }}>
                        Titulo de la ventana
                    </div>
                }
                footer={null}
            >
                <PermissionEditable {...permissionEditableProps} />
            </Modal>
        </>
    );

}